import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/shared/services/session.service';
import { canPickCompany } from 'src/app/shared/utilities/company-scope';
import { ICompany } from '../../../companies/models/company.interface';

@Component({
  selector: 'app-tab-dados-fila',
  templateUrl: './tab-dados-fila.component.html',
  styleUrls: ['./tab-dados-fila.component.scss']
})
export class TabDadosFilaComponent {
  @Input() formFila: UntypedFormGroup = new UntypedFormGroup({});
  @Input() companies: ICompany[] = [];
  @Input() companyId?: string;
  // Usuário de empresa mantém a empresa da fila; interno e parceiro sem empresa podem trocá-la.
  readonly podeEscolherEmpresa: boolean;

  constructor(
    private readonly router: Router,
    sessionService: SessionService
  ) {
    this.podeEscolherEmpresa = canPickCompany(sessionService.getSession());
  }

  public abrirEmNovaAba(filaId: string): void {
    const url = this.router.serializeUrl(this.router.createUrlTree([`/dash/fila/editar/${filaId}`]));

    window.open(url, '_blank');
  }
}
